import { Injectable } from "@angular/core";
import { WebStorage } from "./web.storage";
import { FormControl, AbstractControl } from "@angular/forms";

@Injectable()
export class Utills {
  constructor(private storage: WebStorage) {}

  isArray(value: any) {
    return value && typeof value === "object" && value.constructor === Array;
  }

  isExists(data: any, key: any) {
    if (this.notEmpty(data)) {
      if (this.notEmpty(data[key])) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  notEmpty(data: any) {
    let res = true;
    let dataType = typeof data;
    switch (dataType) {
      case "object":
        if (data == null || data.length < 1) res = false;
        break;

      case "undefined":
        res = false;
        break;

      case "number":
        if (data == "") res = false;
        break;
      case "string":
        if (data.trim() == "") res = false;
        break;
    }

    return res;
  }

  parseJson(data: any) {
    return JSON.parse(data);
  }

  blockNegative(numberInput: any) {
    if (numberInput >= 48 && numberInput <= 57) {
      return true;
    } else {
      return false;
    }
  }

  dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: "image/jpg"
    });
  }

  validateNum(event: any, control: AbstractControl) {
    const pattern = /^[0-9]+$/;
    let value = event.target.value;
    // //console.log())
    if (value.substring(value.indexOf("+") + 1, value.length).match(pattern)) {
      if (!(value.indexOf("+") == 0)) {
        value = "+" + value;
        control.patchValue(value);
        //console.log("phone value ",control.value)
      }
      if (control.value.length > 16) {
        event.preventDefault();
        control.patchValue(value.substring(0, value.length - 1));
        return;
      }
    } else {
      event.target.value = "";
      control.patchValue("");
      return;
    }
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      //console.log("phone ",control.value)
    }
  }
  
// Utility function for validating a number with specified length
  validateNumberLength(event:any, length: number, control:AbstractControl){
    const pattern = /^[0-9]+$/;
    let value = event.target.value;
    // //console.log())
    if (value.substring(value.indexOf("+") + 1, value.length).match(pattern)) {
      if (!(value.indexOf("+") == 0)) {
        value = "+" + value;
        control.patchValue(value);
        //console.log("phone value ",control.value)
      }
      if (control.value.length > length) {
        event.preventDefault();
        control.patchValue(value.substring(0, value.length - 1));
        return;
      }
    } else {
      event.target.value = "";
      control.patchValue("");
      return;
    }
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      //console.log("phone ",control.value)
    }
  }
}
